import { TableBody } from './TableBody';
import { TableHeader } from './TableHeader';
import { useLocalization } from '~/framework';
import { Table, TableContainer } from '@chakra-ui/react';
import { useQuizSessionsContext } from '../QuizSessionsContext';
import { InfiniteScrollForIncrementalQuery } from '~/ui-components';

export function QuizSessionTable() {
   const { _js } = useLocalization();
   const { quizSessionsQuery, bulkCancelQuizSession } = useQuizSessionsContext();

   return (
      <TableContainer>
         <InfiniteScrollForIncrementalQuery
            contained={false}
            query={quizSessionsQuery}
            loadingLabel={_js('Loading quiz sessions')}
         >
            <Table variant="unstyled" style={{ borderCollapse: 'separate', borderSpacing: '3px' }}>
               <TableHeader />
               {!bulkCancelQuizSession.isLoading && <TableBody />}
            </Table>
         </InfiniteScrollForIncrementalQuery>
      </TableContainer>
   );
}
